import { MediaFile } from '../../formats/video-sdk3/lib/vast/media-file';

export const TRACKING_FRAMEWORK_VPAID: string = 'vpaid';
export const TRACKING_FRAMEWORK_OMID: string = 'omid';

export type TrackingFramework = string | null;

function hasVpaidMediaFile(mediaFiles: MediaFile[]): number {
  return getVpaidMediaFiles(mediaFiles).length;
}

function hasOnlyVpaidMediaFile(mediaFiles: MediaFile[]): boolean {
  return (
    mediaFiles.filter(
      m =>
        !m.apiFramework ||
        m.apiFramework.toLowerCase() !== TRACKING_FRAMEWORK_VPAID
    ).length === 0
  );
}

export function getVpaidMediaFiles(mediaFiles: MediaFile[]): MediaFile[] {
  return mediaFiles.filter(m => isMediaFileVpaid(m));
}

export function isMediaFileVpaid(
  mediaFile: MediaFile | null | undefined
): boolean {
  return !!(
    mediaFile &&
    mediaFile.apiFramework &&
    mediaFile.apiFramework.toLowerCase() === TRACKING_FRAMEWORK_VPAID
  );
}

export function getNonVpaidMediaFiles(mediaFiles: MediaFile[]): MediaFile[] {
  return mediaFiles.filter(
    m =>
      !m.apiFramework ||
      m.apiFramework.toLowerCase() !== TRACKING_FRAMEWORK_VPAID
  );
}

export function getTrackingFramework(
  mediaFiles: MediaFile[],
  config: FormatConfig
): TrackingFramework {
  if (isOmidTrackingPrioritized(config)) {
    return TRACKING_FRAMEWORK_OMID;
  }

  if (isVpaidTrackingPrioritized(mediaFiles, config.hasVpaidTracking)) {
    return TRACKING_FRAMEWORK_VPAID;
  }

  return null;
}

function isOmidTrackingPrioritized(config: FormatConfig): boolean | undefined {
  return config.omidTrackingEnabled;
}

export function shouldLoadVpaidVideoFile(
  mediaFiles: MediaFile[],
  config: FormatConfig
): boolean {
  return (
    hasOnlyVpaidMediaFile(mediaFiles) ||
    (isVpaidTrackingPrioritized(mediaFiles, config.hasVpaidTracking) &&
      !isOmidTrackingPrioritized(config))
  );
}

export function isVpaidTrackingPrioritized(
  mediaFiles: MediaFile[],
  hasVpaidTracking?: boolean
): boolean {
  return hasVpaidMediaFile(mediaFiles) > 0 && !!hasVpaidTracking;
}
